type IubendaPreferences = {
  purposes?: Record<string, boolean>;
};

const measurementPurposeId = '4';
const deferredMeasurementDelayMs = 20_000;

const shouldDeferMeasurementOnPath = (pathname: string): boolean =>
  pathname === '/blog' || pathname.startsWith('/blog/');

const getMeasurementConsent = (preferences?: IubendaPreferences): boolean | null => {
  const purposes = preferences?.purposes;
  if (!purposes || !Object.prototype.hasOwnProperty.call(purposes, measurementPurposeId)) {
    return null;
  }

  return purposes[measurementPurposeId] === true;
};

export { deferredMeasurementDelayMs, getMeasurementConsent, measurementPurposeId, shouldDeferMeasurementOnPath };
export type { IubendaPreferences };
